import { render, staticRenderFns } from "./playerData.vue?vue&type=template&id=4eea2459&scoped=true&"
import script from "./playerData.vue?vue&type=script&lang=js&"
export * from "./playerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eea2459",
  null
  
)

export default component.exports